import {
  DELIVERY_PRICE_ALL,
  DELIVERY_PRICE_CREATE,
  DELIVERY_PRICE_GET,
  DELIVERY_PRICE_UPDATE,
  DELIVERY_PRICE_DELETE,
} from '../../actions/types';

const initialState = {
  serials: null,
  isLoading: true,
  isCompleted: false,
};
export default function (state = initialState, action) {
  switch (action.type) {
    case DELIVERY_PRICE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case DELIVERY_PRICE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case DELIVERY_PRICE_CREATE:
      return { isLoading: true, isCompleted: true };
    case DELIVERY_PRICE_UPDATE:
      return { isLoading: true, isCompleted: true };
    case DELIVERY_PRICE_DELETE:
      return { isLoading: true, isCompleted: true };
    default:
      return state;
  }
}
